const ALL = "all";
const AVAILABLE_CONSTRAINT = "availableconstraint";
const CATEGORY_SCHEME = "categoryscheme";
const DATA = "data";
const DATAFLOW = "dataflow";
const CATEGORY_SCHEME_RESULTS = "categorySchemes";
const CATEGORY_RESULTS = "categories";
const LISTS = {
  agencyscheme: "agencySchemes",
  categoryscheme: "categorySchemes",
  codelist: "codelists",
  conceptscheme: "conceptSchemes",
  contentconstraint: "contentConstraints",
  dataflow: "dataflows",
  datastructure: "dataStructures"
};
export {
  ALL,
  AVAILABLE_CONSTRAINT,
  CATEGORY_RESULTS,
  CATEGORY_SCHEME,
  CATEGORY_SCHEME_RESULTS,
  DATA,
  DATAFLOW,
  LISTS
};
